export default "__VITE_ASSET__7ac2b8e2__"